export default function NoAutorizado() {
  return (
    <div style={{ padding: "2rem" }}>
      <h2>No autorizado</h2>
      <p>No tienes permisos para acceder a esta sección.</p>
    </div>
  );
}
